import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface AuthPageShellProps {
  children: ReactNode;
}

export function AuthPageShell({ children }: AuthPageShellProps) {
  const { t } = useTranslation('knox-aiops');

  return (
    <div className="flex h-screen flex-col bg-white font-[Inter,sans-serif] text-foreground">
      {/* Header */}
      <header className="flex shrink-0 w-full items-center justify-between px-6 py-3 bg-white/80 backdrop-blur-md border-b border-black/[0.04]">
        <div className="flex items-center gap-2">
          <img src="/knox-logo.png" alt="Knox" className="h-7 w-auto" />
          <span className="font-heading text-xl font-extrabold tracking-tighter text-foreground">Knox</span>
        </div>
      </header>

      {/* Main */}
      <main className="relative flex flex-1 min-h-0 flex-col items-center justify-center overflow-auto px-4 py-6">
        <div className="knox-dot-grid pointer-events-none absolute inset-0 opacity-10" />
        <div className="knox-card-glass relative w-full max-w-[420px] p-6 sm:p-8">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="shrink-0 w-full bg-white">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-2 px-8 py-4">
          <span className="text-[0.6875rem] uppercase tracking-widest text-muted-foreground/60">{t('login.copyright')}</span>
          <div className="flex gap-6">
            <a href="/terms" className="text-[0.6875rem] uppercase tracking-widest text-muted-foreground/40 transition-colors hover:text-primary hover:underline underline-offset-4">{t('login.termsOfService')}</a>
            <a href="/privacy" className="text-[0.6875rem] uppercase tracking-widest text-muted-foreground/40 transition-colors hover:text-primary hover:underline underline-offset-4">{t('login.privacyPolicy')}</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
